import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class GridAccordion extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            details: []
        }

        this.itemHeights = []
    }

    prepare() {
        Scroll.on('resize', this.handleResize)

        this.ref.details.forEach(detail => {
            detail.addEventListener('toggle', this.handleToggle)
        })

        this.resize()
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    resize = () => {
        this.itemHeights = []

        this.ref.details.forEach(detail => {

            detail.style.setProperty("--contentHeight", "-" + (detail.querySelector('& > div').clientHeight) + "px")
            
            detail.setAttribute('data-height', detail.querySelector('& > div').clientHeight)
        })
    }

    handleToggle = (event) => {
        event.preventDefault()
        console.log(event.target);
    }
}

